export const breakpoints = {
    isMobile: 768
}